import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-6 col-md-2" }
const _hoisted_5 = { class: "col-6 col-md-2" }
const _hoisted_6 = { class: "col-6 col-md-2" }
const _hoisted_7 = { class: "col-6 col-md-2" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "col-6 col-md-2" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-6 col-md-2" }
const _hoisted_12 = { class: "row mt-2" }
const _hoisted_13 = { class: "col-md-12 table-responsive" }
const _hoisted_14 = { class: "table align-middle mb-0 table-hover" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "nowrap-celular" }
const _hoisted_17 = { class: "nowrap-celular" }
const _hoisted_18 = { class: "nowrap-celular" }
const _hoisted_19 = { class: "text-center text-nowrap" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "card-footer" }
const _hoisted_22 = { class: "row mt-2" }
const _hoisted_23 = { class: "col-md-4" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "col-md-2" }

import { defineComponent, onMounted, reactive } from "vue";

  import BreadCrumb from "../../components/Common/BreadCrumb.vue";

  //servicos
  import * as service from "@/services/parceirosService";
  import {f2dec} from "@/utils/funcoes";

  //componentes
  import Paginador from "@/components/Paginador/Index.vue";
  import DropdownCidadesAtiva from "@/components/Dropdowns/DropdownCidadesAtiva.vue";
  import DropdownVendedores from "@/components/Dropdowns/DropdownVendedores.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

  var controle = reactive({
    filtros: {
      comCidades: true,
      ativo: null,
      voucher: null,
      paginaAtual: 1,
      tamanhoPagina: 10
    } as unknown as service.Filtros,
    itens: [] as service.Parceiro[],
    totalRegistros: 0,

    listaStatus:[ 
      {valor: null, descricao:"- Todos -"},
      {valor: true, descricao:"Ativos"},       
      {valor: false, descricao:"Inativos"},
    ],

    listaVouchers:[ 
      {valor: null, descricao:"- Todos -"},
      {valor: true, descricao:"SIM"},       
      {valor: false, descricao:"NÃO"},
    ],

    status: "",
    erro: "",

    ordenacao: {
      coluna: '',
      asc: true
    },
  })

  onMounted(async ()=>{
    
    pesquisar();
  })

  async function pesquisar() {

    service.obter(controle.filtros)
    .then(r=> {
      controle.itens = r.dados;
      controle.totalRegistros = r.totalRegistros;
    })
    .catch(erro=> {
      controle.erro = erro;
    })
  }

  function ordenarPor(coluna: string) {
    if (controle.ordenacao.coluna === coluna) {
      controle.ordenacao.asc = !controle.ordenacao.asc;
    } else {
      controle.ordenacao.coluna = coluna;
      controle.ordenacao.asc = true;
    }
    controle.itens.sort((a, b) => {
      let valA = (a as Record<string, any>)[coluna];
      let valB = (b as Record<string, any>)[coluna];
      if (typeof valA === 'string') valA = valA.toLowerCase();
      if (typeof valB === 'string') valB = valB.toLowerCase();
      if (valA < valB) return controle.ordenacao.asc ? -1 : 1;
      if (valA > valB) return controle.ordenacao.asc ? 1 : -1;
      return 0;
    });
  }

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, { PageTitle: "Parceiros" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[13] || (_cache[13] = _createElementVNode("label", null, [
              _createElementVNode("i", { class: "flaticon-search" }),
              _createTextVNode(" Pesquisar")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              placeholder: "Nome, código, cnpj...",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).filtros.nome) = $event)),
              onKeyup: pesquisar
            }, null, 544), [
              [_vModelText, _unref(controle).filtros.nome]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[14] || (_cache[14] = _createElementVNode("label", null, "Cidade", -1)),
            _createVNode(DropdownCidadesAtiva, {
              modelValue: _unref(controle).filtros.cidadeId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(controle).filtros.cidadeId) = $event)),
              onChange: pesquisar
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[15] || (_cache[15] = _createElementVNode("label", null, "Vendedor", -1)),
            _createVNode(DropdownVendedores, {
              modelValue: _unref(controle).filtros.usuarioId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(controle).filtros.usuarioId) = $event)),
              onChange: pesquisar
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[16] || (_cache[16] = _createElementVNode("label", null, "Voucher", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(controle).filtros.voucher) = $event)),
              onChange: pesquisar
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).listaVouchers, (item, idx) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item.valor,
                  key: idx
                }, _toDisplayString(item.descricao), 9, _hoisted_8))
              }), 128))
            ], 544), [
              [_vModelSelect, _unref(controle).filtros.voucher]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[17] || (_cache[17] = _createElementVNode("label", null, "Status", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(controle).filtros.ativo) = $event)),
              onChange: pesquisar
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).listaStatus, (item, idx) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item.valor,
                  key: idx
                }, _toDisplayString(item.descricao), 9, _hoisted_10))
              }), 128))
            ], 544), [
              [_vModelSelect, _unref(controle).filtros.ativo]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_RouterLink, {
              class: "btn btn-primary btn-sm mt-4 float-end",
              to: '/parceiros/adicionar'
            }, {
              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                _createElementVNode("i", { class: "flaticon-plus" }, null, -1),
                _createTextVNode(" Adicionar", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("table", _hoisted_14, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (ordenarPor('empresaId'))),
                    class: "th-sortable"
                  }, "Id"),
                  _cache[19] || (_cache[19] = _createElementVNode("th", null, "Foto", -1)),
                  _createElementVNode("th", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (ordenarPor('nome'))),
                    class: "th-sortable"
                  }, "Nome"),
                  _createElementVNode("th", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (ordenarPor('cnpj'))),
                    class: "th-sortable"
                  }, "CNPJ"),
                  _createElementVNode("th", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (ordenarPor('telefone'))),
                    class: "th-sortable"
                  }, "Telefone"),
                  _createElementVNode("th", {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (ordenarPor('celular'))),
                    class: "th-sortable"
                  }, "Celular"),
                  _createElementVNode("th", {
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (ordenarPor('cidadeId'))),
                    class: "th-sortable"
                  }, "Cidade"),
                  _createElementVNode("th", {
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (ordenarPor('ativo'))),
                    class: "th-sortable"
                  }, "Status"),
                  _cache[20] || (_cache[20] = _createElementVNode("th", null, "Opções", -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).itens, (item, idx) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: idx,
                    class: "align-middle"
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.parceiroId), 1),
                    _createElementVNode("td", null, [
                      (item.arquivo)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: item.arquivo,
                            alt: "Foto",
                            class: "rounded",
                            style: {"width":"40px","height":"40px","object-fit":"cover"}
                          }, null, 8, _hoisted_15))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(item.nome), 1),
                    _createElementVNode("td", null, _toDisplayString(item.cnpj), 1),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(item.telefone), 1),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(item.celular), 1),
                    _createElementVNode("td", null, _toDisplayString(item.cidade?.nome), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge rounded-pill", item.ativo ? 'badge-soft-success' : 'badge-soft-danger'])
                      }, _toDisplayString(item.ativo ? 'Ativo' : 'Inativo'), 3)
                    ]),
                    _createElementVNode("td", _hoisted_19, [
                      _createElementVNode("span", null, [
                        _createVNode(_component_RouterLink, {
                          to: '/parceiros/alterar/' + item.parceiroId
                        }, {
                          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                            _createElementVNode("i", { class: "flaticon-pen fs-5" }, null, -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"]),
                        _createElementVNode("a", {
                          class: "ms-2",
                          href: "javascript:void(0);",
                          onClick: ($event: any) => (_ctx.pergExcluir(item))
                        }, [...(_cache[22] || (_cache[22] = [
                          _createElementVNode("i", { class: "flaticon-delete fs-5 text-danger" }, null, -1)
                        ]))], 8, _hoisted_20)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(controle).totalRegistros) + " Registros ", 1),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(Paginador, {
              paginaAtual: _unref(controle).filtros.paginaAtual ?? 1,
              tamanhoPagina: _unref(controle).filtros.tamanhoPagina ?? 20,
              "total-registros": _unref(controle).totalRegistros,
              onOnChange: _cache[12] || (_cache[12] =  (r) => {
                _unref(controle).filtros.paginaAtual = r.paginaAtual;
                _unref(controle).filtros.tamanhoPagina = r.tamanhoPagina;
                pesquisar();
            })
            }, null, 8, ["paginaAtual", "tamanhoPagina", "total-registros"])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_RouterLink, {
              class: "btn btn-secondary btn-sm float-end",
              to: '/'
            }, {
              default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                _createElementVNode("i", { class: "flaticon-close" }, null, -1),
                _createTextVNode(" Fechar", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ], 64))
}
}

})